import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { DialogTitle, DialogContent, DialogActions, Grid } from '@mui/material';
import { PedidosContext } from 'contexts/PedidosContext';
import { DropsContext } from 'contexts/DropsContext';
import { useModal } from 'components/Modals';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';

const ImportModal = ({ callback }) => {
  const defaultValues = { integra_access_id: null, pedido: '' };
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postLoading, postImportMarketplace } = useContext(PedidosContext);

  const onSubmit = (data) => postImportMarketplace({ data, cb: callback });

  return (
    <>
      <DialogTitle>Importar Pedido de Marketplace</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12} sm={6}>
            <Dropdown
              control={control}
              label="Marketplace"
              name="integra_access_id"
              options={drops?.IntegraAccess}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="pedido" control={control} label="Pedido" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          loading={postLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Importar
        </Button>
        <Button variant="contained" onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default ImportModal;
